/**
 * Patterns passed to Sentry's `ignoreErrors`. Extracted from src/index.tsx so
 * the list is unit-testable without importing the app bootstrap (which runs
 * `main()` on import). Sentry matches each pattern against the event message:
 * strings match as substrings, RegExps via `.test()`.
 */
export const sentryIgnoreErrors: (string | RegExp)[] = [
  'AbortError',
  'CancelError',
  'Non-Error promise rejection captured',
  /Failed to open IndexedDB/,
  // Facebook/Android in-app-browser noise (WEBAPP-CBZ): FB's injected
  // navigation_performance_logger posts to a destroyed native Java bridge on
  // beforeunload. Not our code — no OnFrontiers frame appears in the stack.
  /Java object is gone/,
  // iOS WKWebView native-bridge noise (WEBAPP-CE8, WEBAPP-CE9, ENG-5833): Apple
  // WebKit rejects window.webkit.messageHandlers.*.postMessage() with these
  // fixed strings (WKUserContentController.mm) when the host app's native
  // handler misbehaves — DuckDuckGo and any iOS in-app browser. We never call
  // webkit.messageHandlers, so these are never ours; they arrive frameless.
  /WKWebView API client did not respond to this postMessage/,
  /The WKWebView was deallocated before the message was delivered/,
  /passed back from the WKWebView API client was unable to be serialized/,
  // DuckDuckGo's injected messaging script (content-scope-scripts,
  // messaging/lib/webkit.js). Its other errors ("an unknown error occurred",
  // "request failed to send") are too generic to filter on message alone.
  /Missing webkit handler: /,
  /window\.webkit\.messageHandlers was absent/,
];
